module.exports = __webpack_public_path__ + "static/example_1_day_no_overlay-cd2f6a75b0a7001e108eaa7ac4f404f2.png";